import React, { useState } from 'react';
import Dialog from '../Dialog/Dialog';
import Button from '../Button/Button';
import Input from '../Input/Input';
import './CreateTeamDialog.css';

interface CreateTeamDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
  isLoading: boolean;
}

const CreateTeamDialog: React.FC<CreateTeamDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading
}) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');
    
    if (!name.trim()) {
      setError('Team name is required');
      return;
    }

    try {
      await onSave(name.trim());
      setName('');
      setError('');
    } catch (err) {
      setError('Failed to create team');
    }
  };

  const handleClose = () => {
    setName('');
    setError('');
    onClose();
  };

  const headerActions = (
    <div className="dialog-header-actions">
      <Button 
        variant="secondary" 
        onClick={handleClose}
        disabled={isLoading}
        size="small"
      >
        Cancel
      </Button>
      <Button 
        variant="primary" 
        onClick={handleSubmit}
        disabled={isLoading}
        isLoading={isLoading}
        size="small"
      >
        Create
      </Button>
    </div>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Create Team"
      headerActions={headerActions}
      showCloseButton={false}
    >
      <div className="create-team-dialog">
        <Input
          label="Team Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (error) setError('');
          }}
          placeholder="Enter team name"
          error={error}
          disabled={isLoading}
          required
        />
      </div>
    </Dialog>
  );
};

export default CreateTeamDialog; 